import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import App from './App';
import './i18n';
import { StaticValuesProvider } from './contexts/StaticValuesContext';
import store from './store';
import MessageHandler from './components/navigation/MessageHandler';
import darkTheme from './themes/darkTheme';
import keycloak from './config/keycloak';
import { initFromKeycloak } from './store/slices/global';
import FullScreenLoading from './pages/FullScreenLoading';

const container = document.getElementById('root');
const root = createRoot(container!);
const theme = {
    name: 'darkTheme',
    definition: darkTheme,
};

const AppTree = (
    <React.StrictMode>
        <Provider store={store}>
            <StaticValuesProvider>
                <span className={theme.name}>
                    <ConfigProvider theme={theme.definition}>
                        <MessageHandler />
                        <Router>
                            <App />
                        </Router>
                    </ConfigProvider>
                </span>
            </StaticValuesProvider>
        </Provider>
    </React.StrictMode>
);

root.render(<FullScreenLoading />);

keycloak
    .init({
        onLoad: 'login-required',
        pkceMethod: 'S256',
        checkLoginIframe: false,
    })
    .then((authenticated) => {
        if (authenticated) {
            const tp = keycloak.tokenParsed;
            const roles: string[] =
                (tp?.resource_access as Record<string, { roles: string[] }> | undefined)?.['bindfind-api']?.roles ?? [];
            store.dispatch(
                initFromKeycloak({
                    sub: tp?.sub ?? '',
                    email: (tp?.email as string) ?? '',
                    firstName: (tp?.given_name as string) ?? '',
                    lastName: (tp?.family_name as string) ?? '',
                    username: (tp?.preferred_username as string) ?? '',
                    roles,
                }),
            );
            root.render(AppTree);
        }
    })
    .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Keycloak init failed', err);
    });
